import React from "react";
import {SIGNIN_TYPES} from "constants/AppConstants.js";
import useSignIn from "hooks/useSignIn";
import {StyleDivWithGap} from "components/Common/StyleDiv";
import {OAuthSignInButtonMedium} from "./OAuthSignInButtonMedium";

interface Props {
  signUp?: boolean;
}

function OAuthSignInButtons({signUp}: Props) {
  const {handlerSignIn} = useSignIn();

  async function handleOAuthSignIn(signInType: any) {
    await handlerSignIn(signInType, {}, signUp);
  }

  return (
    <StyleDivWithGap
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexWrap="wrap"
      gap="10px"
      rowGap="20px"
    >
      <OAuthSignInButtonMedium
        src="assets/images/google-signin.svg"
        onClick={() => handleOAuthSignIn(SIGNIN_TYPES.google)}
      ></OAuthSignInButtonMedium>
      <OAuthSignInButtonMedium
        src="/assets/images/apple-id-sign-up.png"
        onClick={() => handleOAuthSignIn(SIGNIN_TYPES.apple)}
      ></OAuthSignInButtonMedium>
    </StyleDivWithGap>
  );
}

export default OAuthSignInButtons;
